import styled, { css } from 'styled-components';

import { FiltersForm } from '@xing-com/crate-people-directory-filters-form';
import { mediaConfined } from '@xing-com/layout-tokens';
import { spaceXXL, spaceL, scale110 } from '@xing-com/tokens';
import { Headline } from '@xing-com/typography';
import { Row } from '@xing-com/xing-grid';

export const ContentRow = styled(Row)<{
  $isLoading: boolean;
}>`
  ${({ $isLoading }) => ($isLoading ? 'min-height: 80vh;' : '')};
`;

const marginCss = css`
  margin-bottom: ${spaceL};

  @media ${mediaConfined} {
    margin-bottom: ${spaceXXL};
  }
`;

export const StyledHeadline = styled(Headline)`
  ${marginCss};
  margin-top: 0;

  font-weight: 700;
  line-height: 1.25;
  font-size: ${scale110};
`;

export const StyledFiltersForm = styled(FiltersForm)`
  ${marginCss};
`;
